module.exports = __webpack_public_path__ + "static/media/twitter.3a012c94.png";